/**
 * Created by slava on 20.10.2026
 */

// sweeps a light band across the target sprite, the band lights only the sprite's own pixels
// the shader program is shared - one glare at a time looks right
cc.Glare = function (duration, options) {
    cc.ActionInterval.call(this, duration);

    options = options || {};
    this._slope = options.slope !== undefined ? options.slope : 0.5;
    this._width = options.width;
    this._color = options.color || [1, 1, 1, 0.45];
};

cc.Glare.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Glare,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        const program = cleverapps.Shaders.getGlareProgram();
        if (!program) {
            return;
        }

        if (!this.target.normalShader) {
            this.target.normalShader = this.target.getShaderProgram();
        }
        this.target.setShaderProgram(program);
        this._shader = program;
    },

    update: function (dt) {
        if (!this._shader) {
            return;
        }

        const box = this.target.getBoundingBoxToWorld();
        const width = this._width || box.height * 0.6;
        const run = width + box.height * this._slope / 2;
        const x = box.x - run + (box.width + run * 2) * dt;

        this._shader.use();
        this._shader.setUniformLocationWith2f("u_center", x, box.y + box.height / 2);
        this._shader.setUniformLocationWith1f("u_width", width);
        this._shader.setUniformLocationWith1f("u_slope", this._slope);
        this._shader.setUniformLocationWith4f("u_color", this._color[0], this._color[1], this._color[2], this._color[3]);
    },

    _restoreShader: function () {
        if (this.target && this.target.normalShader) {
            this.target.setShaderProgram(this.target.normalShader);
            delete this.target.normalShader;
        }
        delete this._shader;
    },

    _finalize: function () {
        this._restoreShader();
    },

    stop: function () {
        this._restoreShader();

        cc.ActionInterval.prototype.stop.call(this);
    }
});
